var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2572,
	"./chat-icon-bottom-nav-mobile.webp": 2573,
	"./home-icon-bottom-nav-mobile-active.webp": 2574,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2575,
	"./home-icon-bottom-nav-mobile.webp": 2576,
	"./home-icon-bottom-nav-mobile_b.webp": 2577,
	"./me-icon-bottom-nav-mobile-active.webp": 2578,
	"./me-icon-bottom-nav-mobile.webp": 2579,
	"./promo-icon-bottom-nav-mobile-active.webp": 2580,
	"./promo-icon-bottom-nav-mobile.webp": 2581,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2582,
	"./sponsor-icon-bottom-nav-mobile.webp": 2583,
	"./stream-icon-bottom-nav-mobile-active.webp": 2584,
	"./stream-icon-bottom-nav-mobile.webp": 2585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2571;